<template>
	<div id="reportPage">
		<wc-header headerTitle="报告展示" :BackisShow=BackisShow :closeIsShow=closeIsShow></wc-header>
		<wc-report></wc-report>
	</div>
</template>

<script>
	export default{
		name:'Report',
		data(){
			return {
				BackisShow:false,
				closeIsShow:false,
			}
		},
		methods:{
			calculateHeight(){
				//首先获取页面的高度
				var bodyHei = document.documentElement.clientHeight;
				//tabbar的高度为
				var tabbarHei = 51;
				//设置内容区的高度
				var minePage = document.getElementById("reportPage");
				minePage.style.height = bodyHei-tabbarHei+"px";
			},
			getCurPath(){
				console.log(this.$route)
				var path = this.$route.path;
				//alert(path)
				if(path=='/index/report'){
					this.calculateHeight();
				}
				if(path=="/report"){
					this.closeIsShow=true;
				}
			},
		},
		mounted() {
			//this.calculateHeight();
			this.getCurPath();
		}
	}
</script>

<style scoped="scoped">
	#reportPage{
		overflow-y: auto;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/report/Report.vue